import * as React from 'react'

import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'

import useTheme from '@mui/material/styles/useTheme'
interface Props {
  onClick: () => void
}

export function EmptyState(props: Props) {
  const { onClick } = props
  const theme = useTheme()

  return (
    <Box width={358}>
      <Paper>
        <Box p={3} textAlign="center" color={theme.palette.text.primary}>
          <Typography variant="h6" mb={2}>
            Assignment Rules
          </Typography>
          <Typography variant="body2" mb={4}>
            Create assignment rules to automatically assign ownership of leads
            and opportunities based on custom criteria.
          </Typography>
          <Button
            onClick={() => onClick()}
            variant="contained"
            size="medium"
            color="primary"
            fullWidth
            data-test-id="createAssignmentRuleBtn"
          >
            Create New Assignment Rule
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
